export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/whiteMarker.c54da09d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};